import { queryOptions } from '@tanstack/react-query';

import { getProfileRequest } from './student.requests';

export const getProfileOptions = () =>
  queryOptions({
    queryFn: () => getProfileRequest(),
    queryKey: ['profile'],
  });
